module.exports = __webpack_public_path__ + "img/9788958281931.a73ea1d0.jpg";